<template lang="">
  <div>
    <b-modal
      ref="modal-qualifaction"
      centered
      title="Qualifizieren"
      ok-title="Ok"
      cancel-title="Abbrechen"
      cancel-variant="outline-secondary"
      :no-close-on-backdrop="true"
      @ok="qualificationSubmitted"
    >
      Anfrage qualifizieren.

      <b-form>
        <b-form-group label-for="vue-select">
          <v-select
            v-model="selectedOption"
            :clearable="false"
            :options="this.qualificationOptions"
            placeholder="Auswahl"
            @option:selected="onChange($event)"
          />
        </b-form-group>
        <b-form-group
          label="Begründung (optional)"
          label-for="qualification-notes"
          class="mt-2"
        >
          <b-form-textarea
            id="qualification-notes"
            v-model="qualificationNotes"
            placeholder="Warum wurde diese Qualifizierung gewählt?"
            rows="3"
          />
        </b-form-group>
      </b-form>
    </b-modal>
    <b-modal
      id="modal-confirm-email"
      ref="modalConfirmEmail"
      centered
      title="E-Mail Bestätigung"
      ok-title="Ja, senden"
      cancel-title="Nein"
      @ok="sendEmail"
    >
      Möchten Sie eine Ausgebucht-Benachrichtigung per E-Mail senden?
    </b-modal>
  </div>
</template>
<script>
import {
  BCard,
  VBModal,
  BModal,
  BTable,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormCheckbox,
  BDropdown,
  BDropdownItem,
  VBToggle,
  BDropdownDivider,
  BFormSelect,
  BButton,
  BPagination,
  BFormInput,
  BBadge,
  BFormTextarea,
} from 'bootstrap-vue'

import Inquiry from '@/store/inquiry/Inquiry'
import sendEmail from '@/service/emailService'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BTable,
    BRow,
    BCol,
    BFormCheckbox,
    BDropdown,
    BDropdownItem,
    BPagination,
    VBModal,
    BModal,
    VBToggle,
    // Inquiry,
    vSelect,
    BDropdownDivider,
    BFormSelect,
    BButton,
    // inquiriesHelper,
    BFormInput,
    BBadge,
    BForm,
    BFormGroup,
    BFormTextarea,
  },

  directives: {
    'b-toggle': VBToggle,
    'b-modal': VBModal,
  },

  props: {
    selectedInquiry: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      selectedOption: '',
      qualificationNotes: '',
      qualificationOptions: Inquiry.qualificationOptions,
      inquiry: Inquiry,
    }
  },

  methods: {
    show() {
      this.$refs['modal-qualifaction'].show()
    },

    onChange(events) {
      this.selectedOption = events
    },

    // showQualificationModal(item) {
    //   // alert('showQualificationModal')
    //   this.selectedInquiry = item
    //   this.selectedOption = item.qualification
    //   this.$refs['modal-qualifaction'].show()
    // },

    qualificationSubmitted() {
      const userData = JSON.parse(localStorage.getItem('user') || '{}')
      const user = userData.user || {}

      // Create new history entry
      const newEntry = {
        qualification: this.selectedOption,
        notes: this.qualificationNotes || null,
        by: user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : 'Unknown',
        at: new Date().toISOString(),
      }

      // Get existing history or initialize empty array
      const history = this.selectedInquiry.qualificationHistory || []

      // Append new entry to history
      history.push(newEntry)

      // Update inquiry
      this.selectedInquiry.qualification = this.selectedOption
      this.selectedInquiry.qualificationHistory = history

      this.$store.dispatch('updateInquiry', this.selectedInquiry)

      // Reset textarea for next use
      this.qualificationNotes = ''

      if (this.selectedInquiry.qualification === 'Abgelehnt') {
        this.$refs.modalConfirmEmail.show()
      }
    },

    sendEmail() {
      // Logik zum Senden der E-Mail
      console.log('E-Mail wird gesendet...')
      // Anschließend die Anfrage im Store aktualisieren
      this.onSendEmail(this.selectedInquiry)
    },

    async onSendEmail(selectedInquiry) {
      // const emailType = 'offer'
      // const emailBody = emailStoragesBody(offer.storages, emailType)

      const email = {
        to: selectedInquiry.email,
        subject: 'Der Lagermeister',
        text: 'Hallo',
        template_id: 'd-0163bafb1d0c4ffca6b2ad5f9f1cccc6',
        dynamic_template_data: {
          salutation: selectedInquiry.salutation,
          lastName: selectedInquiry.lastName,
        },
      }

      try {
        const result = await sendEmail(email)

        if (result.success) {
          this.selectedInquiry.status = 'rejected'
          this.$store.dispatch('updateInquiry', this.selectedInquiry)

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'E-Mail erfolgreich versendet',
              icon: 'CheckCircleIcon',
              variant: 'success',
              text: result.message
            }
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'E-Mail Fehler',
              icon: 'AlertCircleIcon',
              variant: 'danger',
              text: result.message
            }
          })
        }
      } catch (error) {
        console.error('Email sending error:', error)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'E-Mail konnte nicht versendet werden',
            icon: 'XCircleIcon',
            variant: 'danger',
            text: error.message || 'Ein unerwarteter Fehler ist aufgetreten'
          }
        })
      }
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
